import { render, staticRenderFns } from "./RentalObjectHide.vue?vue&type=template&id=0b6ce046&scoped=true&"
import script from "./RentalObjectHide.vue?vue&type=script&lang=js&"
export * from "./RentalObjectHide.vue?vue&type=script&lang=js&"
import style0 from "./RentalObjectHide.vue?vue&type=style&index=0&id=0b6ce046&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6ce046",
  null
  
)

export default component.exports